/**
 * Resolve CSS custom properties to computed RGB strings for Chart.js canvas rendering.
 * Canvas contexts cannot read CSS variables directly — this bridges the gap so chart
 * colors stay in sync with the active theme.
 */

/** Resolve a CSS custom property (e.g. '--chart-1') to its computed rgb() string. */
export function resolveCssColor(cssVar: string): string {
	const el = document.createElement('div');
	el.style.setProperty('color', `var(${cssVar})`);
	el.style.position = 'absolute';
	el.style.visibility = 'hidden';
	document.body.appendChild(el);
	const color = getComputedStyle(el).color;
	document.body.removeChild(el);
	return color;
}

/**
 * Apply an alpha fraction to any CSS color string (hex, rgb(), oklch(), etc.)
 * via `color-mix()`. Canvas 2D contexts parse `color-mix()` natively, so this
 * works uniformly regardless of how the browser serializes the computed color
 * (the old regex-based approach only handled hex/rgb — a computed color that
 * serializes as `oklch(...)` would have its channel numbers mis-read as R/G/B,
 * producing near-black garbage; see #873 §16.9).
 */
export function colorWithAlpha(color: string, alpha: number): string {
	return `color-mix(in oklab, ${color} ${alpha * 100}%, transparent)`;
}
